import { useTranslation } from 'next-i18next'

import { BUTTON_TYPES } from './types'
import { LinkButton } from './'

export function OpenTwistButton({ type = BUTTON_TYPES.NORMAL }) {
    const { t } = useTranslation('common')
    const baseURL = process.env.BASE_URL
    return (
        <LinkButton href={`${baseURL}/a/`} type={type}>
            {t('menu.openTwist')}
        </LinkButton>
    )
}
